class MDBladeGuardBlock extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.md-blade-guard-block__toggle');
    this.infoButton = this.querySelector('.md-blade-guard-block__info');
    this.modal = this.querySelector('.md-blade-guard-block__modal');
    this.closeButton = this.querySelector('.md-blade-guard-block__close');
    this.overlay = this.querySelector('.md-blade-guard-block__overlay');
    this.lines = Array.from(this.querySelectorAll('.md-blade-guard-block__line'));

    this.bindModal();
    this.bindProductForm();
  }

  bindModal() {
    this.addEventListener('click', (event) => {
      const shouldOpen =
        event.target.closest('.md-blade-guard-block__info') ||
        event.target.closest('.md-blade-guard-block__images') ||
        event.target.closest('.md-blade-guard-block__image') ||
        event.target.closest('.md-blade-guard-block__more');

      if (!shouldOpen) return;

      event.preventDefault();
      event.stopPropagation();
      this.openModal();
    });

    if (this.closeButton) this.closeButton.addEventListener('click', () => this.closeModal());
    if (this.overlay) this.overlay.addEventListener('click', () => this.closeModal());

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeModal();
    });
  }

  bindProductForm() {
    const productSection = this.closest('section') || document;
    const form =
      this.closest('form[action*="/cart/add"]') ||
      productSection.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    form.addEventListener('submit', () => {
      if (!this.toggle || !this.toggle.checked || this.lines.length === 0) return;
      this.addBladeGuardsOnly(form);
    }, true);
  }

  async addBladeGuardsOnly(form) {
    const formData = new FormData(form);
    const quantity = Number(formData.get('quantity') || 1);

    const itemsMap = new Map();

    this.lines.forEach((line) => {
      const bladeVariantId = line.dataset.variantId;
      if (!bladeVariantId) return;

      const key = String(bladeVariantId);
      const existing = itemsMap.get(key);

      if (existing) {
        existing.quantity += quantity;
      } else {
        itemsMap.set(key, {
          id: Number(bladeVariantId),
          quantity
        });
      }
    });

    const items = Array.from(itemsMap.values());
    if (!items.length) return;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error('Blade guards add failed');

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:added:blade-guards', { bubbles: true, detail: { items } }));
    } catch (error) {
      console.error('[Maison Damas] Erreur ajout protège-lames', error);
    }
  }

  copyColorVariablesToModal() {
    if (!this.modal) return;

    const variables = [
      '--md-card-bg',
      '--md-card-border',
      '--md-main-text',
      '--md-sub-text',
      '--md-info-border',
      '--md-info-text',
      '--md-info-bg',
      '--md-switch-on',
      '--md-switch-off',
      '--md-switch-knob',
      '--md-popup-bg',
      '--md-popup-text'
    ];

    const computed = window.getComputedStyle(this);

    variables.forEach((variable) => {
      const value = computed.getPropertyValue(variable);
      if (value) this.modal.style.setProperty(variable, value.trim());
    });

    this.modal.classList.toggle(
      'md-blade-guard-block__modal--custom',
      this.classList.contains('md-blade-guard-block--custom')
    );
  }

  openModal() {
    if (!this.modal) return;

    this.modalPlaceholder = document.createComment('md-blade-guard-modal-placeholder');
    this.modal.parentNode.insertBefore(this.modalPlaceholder, this.modal);

    this.copyColorVariablesToModal();

    document.body.appendChild(this.modal);
    this.modal.hidden = false;
    document.documentElement.classList.add('md-blade-guard-modal-open');

    const panel = this.modal.querySelector('.md-blade-guard-block__panel');
    if (panel) panel.scrollTop = 0;
  }

  closeModal() {
    if (!this.modal) return;

    this.modal.hidden = true;
    document.documentElement.classList.remove('md-blade-guard-modal-open');

    if (this.modalPlaceholder && this.modalPlaceholder.parentNode) {
      this.modalPlaceholder.parentNode.insertBefore(this.modal, this.modalPlaceholder);
      this.modalPlaceholder.remove();
      this.modalPlaceholder = null;
    }
  }
}

if (!customElements.get('md-blade-guard-block')) {
  customElements.define('md-blade-guard-block', MDBladeGuardBlock);
}
